/** Dropdown options for header search filters: value is the condition id sent to the search API. */
export function getSearchFilterConditionOptions(
  conditions: { id: string; name: string }[]
): { label: string; value: string }[] {
  const out: { label: string; value: string }[] = [];
  for (const condition of conditions) {
    if (condition.id) {
      out.push({ label: condition.name, value: condition.id });
    }
  }
  return out;
}
